import React from "react";
import { getTranslation } from "../../../../assets/creator/translations";
import SidebarStyleMenuRouter from "../SidebarStyleMenuRouter";




const StyleMenuRoot = ({
  onSelect,
  path,
  root,
  onBackButtonPress,
  onEditClick,
  onColorVariablesBackButtonPress,
  containerRef,
  onFontSelect,
  styleSettings,
  onIconStyleSelect,
  onCartIconStyleSelect,
  currentIconStyle,
  onColorSelect,
  colorSource,
  currentThemeName,
  _currentFont,
  currentViewColor,
  onSelectColor,
  onSpinnerIconStyleSelect,
  ...props
}) => (
  <React.Fragment>
    {path === "colorVariables" && (
      <SidebarStyleMenuRouter
        {...props}
        onColorSelect={onColorSelect}
        colorSource={colorSource}
        onSelect={onSelect}
        path={path}
        onThemeSelect={props.onThemeSelect}
        currentThemeName={currentThemeName}
        onSelectColor={onSelectColor}
        root={root}
        defaultRoute={root}
        onBackButtonPress={onColorVariablesBackButtonPress}
        onEditClick={onEditClick}
        onColorVariablesBackButtonPress={onColorVariablesBackButtonPress}
        containerRef={containerRef}
      ></SidebarStyleMenuRouter>
    )}
    {path !== "colorVariables" && (
      <ul className="style-menu" >
        <div className="style-menu-container">
          <li
            className="style-menu__option style-menu__option1 style-menu__option__inactive"
            onClick={() => {
              onSelect("themes");
              const liElement1 = document.querySelector(".style-menu__option1");
              const liElement2 = document.querySelector(".style-menu__option2");
              const liElement3 = document.querySelector(".style-menu__option3");
              
              liElement2.classList.remove("style-menu__option__active");
              liElement3.classList.remove("style-menu__option__active");
              liElement1.classList.toggle("style-menu__option__active");

            }}

            
            
          >
            <span className="style-menu__label">
              {getTranslation("ColorTheme")}
            </span>
          </li>
          {path === "themes" && (
            <SidebarStyleMenuRouter
              {...props}
              onSelect={onSelect}
              onThemeSelect={props.onThemeSelect}
              onColorSelect={onColorSelect}
              currentViewColor={currentViewColor}
              onSelectColor={onSelectColor}
              currentThemeName={currentThemeName}
              onEditClick={onEditClick}
              onFontSelect={onFontSelect}
              currentFont={styleSettings.fontFamily}
              path={path}
              defaultRoute={root}
              onBackButtonPress={onBackButtonPress}
              onColorVariablesBackButtonPress={onColorVariablesBackButtonPress}
              containerRef={containerRef}
            ></SidebarStyleMenuRouter>
          )}
        </div>

        <div className="style-menu-container">
          <li
            className="style-menu__option style-menu__option2 style-menu__option__inactive"
            onClick={() => {
              onSelect("fonts");
              const liElement1 = document.querySelector(".style-menu__option1");
              const liElement2 = document.querySelector(".style-menu__option2");
              const liElement3 = document.querySelector(".style-menu__option3");
              liElement1.classList.remove("style-menu__option__active");
              liElement3.classList.remove("style-menu__option__active");
              liElement2.classList.toggle("style-menu__option__active");
            }}
          >
            <span className="style-menu__label">{getTranslation("Fonts")}</span>
          </li>
          {path === "fonts" && (
            <SidebarStyleMenuRouter
              onFontSelect={onFontSelect}
              styleSettings={styleSettings}
              path={path}
              defaultRoute={root}
              onBackButtonPress={onBackButtonPress}
              onEditClick={onEditClick}
              onColorVariablesBackButtonPress={onColorVariablesBackButtonPress}
              containerRef={containerRef}
            />
          )}
        </div>
        <div className="style-menu-container">
          <li
            className="style-menu__option style-menu__option3 style-menu__option__inactive"
            onClick={() => {
              onSelect("icons");
              const liElement1 = document.querySelector(".style-menu__option1");
              const liElement2 = document.querySelector(".style-menu__option2");
              const liElement3 = document.querySelector(".style-menu__option3");
              liElement1.classList.remove("style-menu__option__active");
              liElement2.classList.remove("style-menu__option__active");
              liElement3.classList.toggle("style-menu__option__active");
            }}
          >
            <span className="style-menu__label">{getTranslation("Icons")}</span>
          </li>
          {path === "icons" && (
            <SidebarStyleMenuRouter
              onIconStyleSelect={onIconStyleSelect}
              styleSettings={styleSettings}
              currentIconStyle={currentIconStyle}
              onCartIconStyleSelect={onCartIconStyleSelect}
              path={path}
              defaultRoute={root}
              onBackButtonPress={onBackButtonPress}
              onEditClick={onEditClick}
              onColorVariablesBackButtonPress={onColorVariablesBackButtonPress}
              containerRef={containerRef}
              onSpinnerIconStyleSelect={onSpinnerIconStyleSelect}
            />
          )}
        </div>
      </ul>
    )}
  </React.Fragment>
);

export default StyleMenuRoot;
